import React from "react";
import Milestone from "./Milestone";
import moniepoint from "../../../asset/moniepoint.svg"
import primhex from "../../../asset/primhex.png"
import "./ExperienceTimeline.css";

const ExperienceTimeline = () => {
  const milestones = [
    {
      title: "Frontend Engineer at Moniepoint Inc",
      img: moniepoint,
      description: "Worked on developing responsive web applications using React.",
      date: "August 2021 - Present",
      isCompleted: true,
    },
    {
      title: "Frontend Engineer at Primhex Logistics",
      img: primhex,
      description: "Involved in full-stack development, primarily focusing on backend services.",
      date: "March 2020 -  July 2021",
      isCompleted: true,
    },
    // {
    //   title: "Junior Developer at 123 Inc",
    //   description: "Gained experience in frontend technologies and participated in various projects.",
    //   date: "Jan 2018 - May 2019",
    //   isCompleted: true,
    // },
    // Add more milestones as needed
  ];

  return (
    <div className="experience-timeline">
      {milestones.map((milestone, index) => (
        <Milestone
          key={index}
          title={milestone.title}
          description={milestone.description}
          date={milestone.date}
          isCompleted={milestone.isCompleted}
          img={milestone.img}
        />
      ))}
    </div>
  );
};

export default ExperienceTimeline;
